import React, { Component } from 'react';
import styles from './contact.css';
import Lang from '../../i18n'
import { withRouter } from 'react-router-dom'

class Contact extends Component {
  render() {
    return (
      <div className={styles.inputWrapperContainer}>
        <div className={styles.inputWrapperContainerInner}>
          <div className={styles.titleContainer}>
            <div className={styles.titleInner}>
              <h2>{Lang.translate('contact:title', this.props.location.pathname)}</h2>
              <p>{Lang.translate('contact:text', this.props.location.pathname)}</p>
              <a className={styles.btn} target="_blank" rel="noopener noreferrer"  href={Lang.translate('contact:link', this.props.location.pathname)}>{Lang.translate('contact:button', this.props.location.pathname)}</a>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default withRouter(Contact);



// WEBPACK FOOTER //
// ./src/components/contact/contact.js